// Header "catch-up": the theme slides the header away while you scroll down and brings it back when
// you scroll up. This also brings it back a moment after you stop scrolling, so it never stays hidden.
(function () {
  var header = document.querySelector('.section-header');
  if (!header) return;
  var timer;
  function later() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (header.classList.contains('section-header-hidden') && !header.classList.contains('menu-open')) {
        header.classList.add('section-header-sticky', 'animate');
        header.classList.remove('section-header-hidden');
      }
    }, 350);
  }
  window.addEventListener('scroll', later, { passive: true });
  // the theme hides the header on the next animation frame, so restart the wait whenever it actually hides
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (header.classList.contains('section-header-hidden')) later();
    }).observe(header, { attributes: true, attributeFilter: ['class'] });
  }
})();
